module.exports = __webpack_public_path__ + "static/media/ico-facebook.c573d8e0.jpg";